import { motion } from "framer-motion";
import { ServiceCard } from "../sections/ServicesSection";
import PageHero from "../components/PageHero";
import CtaBand from "../components/CtaBand";
import { SERVICES } from "../data/content";
import { stagger, usePageMeta } from "../lib/motion";

const ServicesPage = () => {
  usePageMeta("Our Services", "Work permit, visitor, student, family/spouse and business visa services with documentation assistance from The Trip World.");
  return (
    <main data-testid="services-page">
      <PageHero
        eyebrow="OUR SERVICES"
        title="GUIDANCE FOR EVERY"
        highlight="VISA JOURNEY"
        description="Six focused services covering the full spectrum of international travel and immigration needs."
      />
      <section className="py-20 lg:py-28 bg-navy">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            variants={stagger}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-60px" }}
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
          >
            {SERVICES.map((s, i) => (
              <ServiceCard key={s.slug} service={s} index={i} />
            ))}
          </motion.div>
        </div>
      </section>
      <CtaBand />
    </main>
  );
};

export default ServicesPage;
